import { render } from "./RequestTypeManagement.vue?vue&type=template&id=4ede827e"
import script from "./RequestTypeManagement.vue?vue&type=script&lang=js"
export * from "./RequestTypeManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__